<template>
	<div class="class-page">
		<div class="top-bar" v-if="customPageId==0">
			<h2>AI智能体互动课堂</h2>
			<button @click="exitClass" class="exit-btn">退出课堂</button>
		</div>
		<button v-if="isMobile&&customPageId==0" class="toggle-left-btn" @click="showLeftPanel = !showLeftPanel">
			{{ showLeftPanel ? '隐藏工具' : '显示工具' }}
		</button>
		<div id="screenContent" class="layout-container">
			<LeftPanel v-if="customPageId==0" v-show="!isMobile || showLeftPanel" :classInfo="classInfo"
				:isClassEnded="isClassEnded" :isLocked="isLocked" @send-msg="handleToolSend" />

			<ChatPanel v-if="customPageId==0" ref="chatPanel" :classInfo="classInfo" :isClassEnded="isClassEnded"
				:isLocked="isLocked" :schoolId="schoolId" :courseClassId="courseClassId" :studentId="studentId"
				:studentName="studentName" />

			<StudentInde ref="studentInde" v-show="customPageId!=0" @toSet="exitClass" :studentName="studentName"
				:studentId="studentId" :disabledMenus="disabledMenus" :schoolId="schoolId"
				:courseClassId="courseClassId" />
		</div>
		<div v-if="isLocked" class="lock-mask">
			<h2>🔒 老师提醒你上课请认真听讲</h2>
			<!-- <el-button type="text" v-if="isFirst" @change="go">返回</el-button> -->
		</div>
		<div v-if="isClassEnded" class="end-mask">
			<h2>✅ 课堂已结束，无法继续操作</h2>
			<el-button type="text"  @change="go">返回</el-button>
		</div>

		<div v-if="showPraiseAnimation" class="praise-animation-container" @click="closePraiseAnimation">
			<div class="praise-content">
				<div class="praise-icon">{{ getPraiseIcon(currentPraise.type) }}</div>
				<div class="praise-text">{{currentPraise.type!="fist"?"老师表扬了你！":"老师提醒你！"}}</div>
				<div class="praise-subtext">{{ getPraiseLabel(currentPraise.type) }}</div>
			</div>
		</div>

		<div v-if="showAlarmAnimation" class="alarm-animation-container" @click="closeAlarmAnimation">
			<div class="alarm-content">
				<div class="alarm-icon-container">
					<div class="alarm-icon">⏰</div>
					<div class="alarm-ring ring-1"></div>
					<div class="alarm-ring ring-2"></div>
					<div class="alarm-ring ring-3"></div>
				</div>
				<div class="alarm-title">⏰ 时间到！</div>
				<div class="alarm-subtitle">{{ currentAlarm.broadcastName }}</div>
				<div class="alarm-timer">
					{{ Math.floor(currentAlarm.remainingTime / 60) }}分{{ currentAlarm.remainingTime % 60 }}秒
				</div>
				<div class="alarm-hint">点击任意处关闭</div>
			</div>
		</div>

		<div class="marquee-notice" v-if="showMarquee && marqueeText">
			<div class="marquee-content" :style="{ animationDuration: `${marqueeSpeed}s` }">
				{{ marqueeText }}
			</div>
		</div>
	</div>
</template>

<script>
	import LeftPanel from './classComponents/LeftPanel.vue'
	import ChatPanel from './classComponents/ChatPanel.vue'
	import StudentInde from './test 1/index.vue'
	import {
		stopLanHeartbeat,
		startLanHeartbeat
	} from "@/views/login.js"

	export default {
		components: {
			LeftPanel,
			ChatPanel,
			StudentInde
		},
		data() {
			return {
				classInfo: {
					courseName: '加载中...',
					teacherName: '加载中'
				},
				isLocked: false,
				isClassEnded: false,

				schoolId: localStorage.getItem('orgId'),
				courseClassId: localStorage.getItem('courseClassId'),
				studentId: localStorage.getItem('userId'),
				studentName: localStorage.getItem('nickName'),
				customPageId: localStorage.getItem('customPageId'),
				userType: localStorage.getItem('userType'),
				fullScreenTimer: null,

				showPraiseAnimation: false,
				currentPraise: {
					type: 'flower'
				},

				pollTimer: null,
				chatPollTimer: null,
				myStatusTimer: null,
				lastChatTime: 0,

				isMobile: false,
				showLeftPanel: false,
				login: null,
				isStopAllPoll: false,
				studentStatus: {
					controlStatus: 0
				},
				endTimestamp: 0,
				marqueeText: '',
				showMarquee: false,
				marqueeSpeed: 10,
				praiseCache: {
					processedIds: [],
					lastPraiseTime: 0,
					praiseDebounceTimer: null,
					isAnimating: false,
					cacheCleanupTimer: null
				},

				alarmCache: {
					processedIds: [],
					lastAlarmTime: 0,
					alarmDebounceTimer: null,
					isAnimating: false,
					cacheCleanupTimer: null
				},
				currentAlarm: {
					broadcastId: null,
					broadcastName: '时间到',
					duration: 0,
					remainingTime: 0
				},
				showAlarmAnimation: false,
				alarmPollTimer: null,
				disabledMenus: '',

				// ======== 推流相关（已修复）========
				peerConnection: null,
				config: {},
				isAnswer: false,
				webrtcOffer: "",
				iceCandidates: [],
				shareTimer: null,
				isPushing: false,
				reportTimer: null,
				isSharing: false,
				isShareStarting: false,
				_drawTimer: null, // Canvas绘制循环
				isFirst:true,
				//新的共有组件
				fullScreenWatchTimer: null, // 全屏监听定时器
			};
		},
		created() {

			this.loginOpen('课堂数据查询中...')
			this.initUser() //统一接口
			// this.startClassPoll()
			// this.startChatPoll()
			this.startMyStatusPoll()
			this.enterClass()
			this.checkIsMobile()
			//监听全屏
			 this.startAutoFullScreenWatch()
			// this.startReport();
		},
		beforeDestroy() {
			// 清理所有
			if (this.reportTimer) {
				clearInterval(this.reportTimer);
				this.reportTimer = null;
			}
			this.stopShare();

			this.exitClass()
			this.stopPoll()
			this.stopChatPoll()
			this.stopAllPoll()
			this.stopAlarmPoll()
			if (this.fullScreenTimer) {
				clearInterval(this.fullScreenTimer)
			}
			if (this.praiseCache.cacheCleanupTimer) clearInterval(this.praiseCache.cacheCleanupTimer)
			if (this.praiseCache.praiseDebounceTimer) clearTimeout(this.praiseCache.praiseDebounceTimer)
			this.stopMirrorPush()

			if (this.ipBroadcastTimer) {
				clearInterval(this.ipBroadcastTimer);
				this.ipBroadcastTimer = null;
			}
			if (this.peerConn) {
				try {
					this.peerConn.close();
				} catch (e) {}
				this.peerConn = null;
			}
			  // 销毁全屏监听
			  if (this.fullScreenWatchTimer) {
			    clearInterval(this.fullScreenWatchTimer)
			    this.fullScreenWatchTimer = null
			  }
			
			  // 移除全屏事件监听
			  const fullscreenEvents = [
			    'fullscreenchange',
			    'webkitfullscreenchange',
			    'mozfullscreenchange',
			    'MSFullscreenChange'
			  ]
			  fullscreenEvents.forEach(evt => {
			    document.removeEventListener(evt, () => {})
			  })
		},
		methods: {
			go(){
				
				this.stopShare()
				this.stopPoll()
				this.stopChatPoll()
				this.stopAllPoll();
				this.$router.go(-1)
			},
			
			// 开始监听全屏状态，非全屏则自动进入全屏
			startAutoFullScreenWatch() {
			  // 先执行一次判断
			  this.checkAndEnterFullScreen()
			  // 轮询监听（避免部分浏览器全屏切换事件失效）
			  if (this.fullScreenWatchTimer) return
			  this.fullScreenWatchTimer = setInterval(() => {
			    this.checkAndEnterFullScreen()
			  }, 3000)
			
			  // 监听窗口/全屏切换事件（优先原生事件）
			  const fullscreenEvents = [
			    'fullscreenchange',
			    'webkitfullscreenchange',
			    'mozfullscreenchange',
			    'MSFullscreenChange'
			  ]
			  fullscreenEvents.forEach(evt => {
			    document.addEventListener(evt, () => {
			      this.checkAndEnterFullScreen()
			    })
			  })
			},
			
			// 判断当前是否全屏，非全屏则进入全屏
			checkAndEnterFullScreen() {
			  // 判断是否处于全屏状态（兼容各浏览器）
			  const isFullScreen = !!(
			    document.fullscreenElement ||
			    document.webkitFullscreenElement ||
			    document.mozFullScreenElement ||
			    document.msFullscreenElement
			  )
			
			  // 未全屏 && 课堂未结束 && 未锁定 才自动全屏（可根据业务删减条件）
			  if (!isFullScreen && !this.isClassEnded && !this.isLocked) {
			    this.enterFullScreen()
			  }
			},
			// ======== 心跳上报 ========
			startReport() {
				if (this.reportTimer) clearInterval(this.reportTimer);
				this.reportTimer = setInterval(async () => {
					const params = new URLSearchParams();
					params.append("courseClassId", this.courseClassId);
					params.append("userId", this.studentId);
					params.append("userType", "3");
					params.append("nickName", this.studentName);
					params.append("isPushing", this.isPushing);
					// 仅在有有效Offer时上报，空内容不上报
					params.append("webrtcOffer", this.webrtcOffer || "");
					params.append("iceCandidates", this.iceCandidates.length ? JSON.stringify(this
						.iceCandidates) : '[]');
					params.append("toTeacherId", '');

					try {
						const res = await this.API.post(this.API.fileurl.postLanPeers, params);
						this.handlePushCmd(res.data || []);
					} catch (err) {
						console.error("心跳上报异常", err);
					}
				}, 3000);
			},

			// ======== 停止推流（完整清理）========
			stopShare() {
				try {
					// 停止绘制循环
					if (this._drawTimer) {
						clearInterval(this._drawTimer);
						this._drawTimer = null;
					}
					if (this.shareTimer) clearInterval(this.shareTimer);
					// 停止轨道
					if (this.peerConnection) {
						this.peerConnection.getSenders().forEach(s => s.track.stop());
						this.peerConnection.close();
						this.peerConnection = null;
					}
					// 清空视频源
					if (this.$refs.videoPlayer) {
						this.$refs.videoPlayer.srcObject = null;
					}
				} finally {
					this.isSharing = false;
					this.isShareStarting = false;
					this.isAnswer = false;
					this.webrtcOffer = "";
					this.iceCandidates = [];
					console.log("✅ 推流已完全停止");
				}
			},

			// ======== 处理老师指令（核心修复）========
			handlePushCmd(data) {
				if (!data || data.length === 0) {
					this.stopShare();
					return;
				}
				const me = data.find(v => v.userType == 3 && v.userId == this.studentId);
				if (!me) {
					this.stopShare();
					return;
				}

				// 老师命令：开始推流
				if (me.toTeacherId) {
					if (!this.isSharing && !this.isShareStarting) {
						console.log("✅ 收到老师指令：启动推流");
						this.startShare();
					}
				} else {
					// 停止推流
					if (this.isSharing) {
						console.log("🛑 收到老师指令：停止推流");
						this.stopShare();
					}
				}

				// 处理老师 Answer（必须执行！）
				const teacher = data.find(v => v.userType == 2);
				if (teacher && teacher.webrtcAnswer && !this.isAnswer) {
					this.isAnswer = true;
					this.onTeacherAnswer(teacher.webrtcAnswer, teacher.iceCandidates || "[]");
				}
			},

			// ======== 接收老师 Answer ========
			async onTeacherAnswer(answerStr, iceStr) {
				try {
					const answer = JSON.parse(answerStr);
					await this.peerConnection.setRemoteDescription(answer);
					const teacherIces = JSON.parse(iceStr || "[]");
					teacherIces.forEach(ice => {
						this.peerConnection.addIceCandidate(ice);
					});
					console.log("✅ 已连接老师");
				} catch (e) {
					console.error("处理Answer失败", e);
				}
			},

			// ======== 启动推流（零卡顿、平板兼容版）========
			async startShare() {
				if (this.isSharing || this.isShareStarting) return;
				this.isShareStarting = true;

				try {
					// 销毁旧连接
					if (this.peerConnection) {
						this.peerConnection.close();
						this.peerConnection = null;
					}
					if (this._drawTimer) {
						clearInterval(this._drawTimer);
						this._drawTimer = null;
					}

					// ==============================================
					// 🔥 核心：用隐藏Canvas中转，支持所有浏览器/平板
					// ==============================================
					const shareDom = this.$refs.shareArea;
					const canvas = this.$refs.captureCanvas;
					if (!shareDom || !canvas) throw new Error("找不到分享区域或Canvas");

					// 1. 初始化Canvas尺寸
					const rect = shareDom.getBoundingClientRect();
					canvas.width = rect.width || 1280;
					canvas.height = rect.height || 720;
					const ctx = canvas.getContext('2d');

					// 2. 创建流（这里用Canvas的captureStream，不会undefined）
					const stream = canvas.captureStream(15); // 15fps 省性能，平板不卡
					this.$refs.videoPlayer.srcObject = stream;

					// 3. 建立WebRTC连接
					this.peerConnection = new RTCPeerConnection(this.config || {});

					// 监听连接状态
					this.peerConnection.onconnectionstatechange = () => {
						console.log("🔗 连接状态:", this.peerConnection.connectionState);
						if (this.peerConnection.connectionState === 'connected') {
							console.log("🎉 WebRTC通道已连通");
						}
					};
					this.peerConnection.oniceconnectionstatechange = () => {
						console.log("❄️ ICE状态:", this.peerConnection.iceConnectionState);
					};

					// 添加视频轨道
					stream.getVideoTracks().forEach(track => {
						this.peerConnection.addTrack(track, stream);
						track.enabled = true; // 强制启用，防止黑屏
					});

					// 4. ICE收集
					this.iceCandidates = [];
					this.peerConnection.onicecandidate = (e) => {
						if (e.candidate) {
							this.iceCandidates.push(e.candidate);
						}
					};

					// 5. 创建Offer
					const offer = await this.peerConnection.createOffer({
						offerToReceiveAudio: false,
						offerToReceiveVideo: false
					});
					await this.peerConnection.setLocalDescription(offer);
					this.webrtcOffer = JSON.stringify(offer);
					this.isSharing = true;

					// 6. 持续绘制Canvas（15fps，不卡主线程）
					this._drawTimer = setInterval(() => {
						try {
							ctx.clearRect(0, 0, canvas.width, canvas.height);
							ctx.drawImage(shareDom, 0, 0, canvas.width, canvas.height);
						} catch (e) {
							// 静默失败，不影响推流
						}
					}, 1000 / 15);

				} catch (err) {
					console.error("推流失败：", err);
				} finally {
					this.isShareStarting = false;
				}
			},

			// ==================== 以下是你原有逻辑，完全不变 ====================
			checkFullScreen() {
				const isFull = !!(
					document.fullscreenElement ||
					document.webkitFullscreenElement ||
					document.msFullscreenElement
				)
				if (!isFull) {
					this.enterFullScreen()
				}
			},
			enterFullScreen() {
				const el = document.documentElement
				if (el.requestFullscreen) {
					el.requestFullscreen()
				} else if (el.webkitRequestFullscreen) {
					el.webkitRequestFullscreen()
				} else if (el.msRequestFullscreen) {
					el.msRequestFullscreen()
				}
			},
			handleToolSend(content) {
				if (this.$refs.chatPanel) {
					this.$refs.chatPanel.sendMsg(content)
				}
			},
			stopAllPoll() {
				clearTimeout(this.pollTimer)
				clearTimeout(this.chatPollTimer)
				clearTimeout(this.myStatusTimer)
				this.pollTimer = null
				this.chatPollTimer = null
				this.myStatusTimer = null
				this.isClassEnded = true
			},
			async initUser() {
				if (this.isClassEnded) return
				try {
					const res = await this.API.get(this.API.school.getInfoById, {
						courseClassId: this.courseClassId,
						studentId: this.studentId,
						schoolId: localStorage.getItem('orgId')
					})
					
					if (res.data.code === 200) {
						this.classInfo = res.data.data
						this.disabledMenus = res.data.data.disabledMenus
						if (this.classInfo.endTimestamp && this.classInfo.noticeText) {
							if (this.endTimestamp == 0 || (this.endTimestamp < this.classInfo.endTimestamp)) {
								this.endTimestamp = this.classInfo.endTimestamp
								if (this.classInfo.noticeText != '0') {
									let time = Number(this.classInfo.noticeText)
									let text = ''
									if (time < 60) {
										text = `⏰ 距离活动结束还剩${time}秒`
									} else {
										let minute = Math.floor(time / 60);
										let second = time % 60;
										text = `⏰ 距离活动结束还剩${minute}分${second}秒`
									}

									this.showMarquee = true
									this.marqueeText = text
									setTimeout(() => {
										this.showMarquee = false
									}, 5000)

								} else {
									this.showAlarmAnimation = true
									setTimeout(() => {
										this.closeAlarmAnimation()
									}, 3000)
								}
							}
						}
						let msg = res.data?.data?.teacherMsg || null

						//新的消息处理
						if (msg) {
							if (msg.type === 'countdown' || msg.noticeText) {
								this.showCountdownNotification(msg)
							} else if (msg.type == 'text') {
								let  content = msg.content || ''
								console.log('msg',msg)
								 content=JSON.parse(content)
								 msg.content=content
								 msg.createTime=res.data.data.createTime
								if (this.customPageId == 1) {
									if (this.$refs.studentInde) {
										this.$refs.studentInde.forChat(msg)
									}
								} else {
									if (this.$refs.chatPanel) {
										this.$refs.chatPanel.receiveTeacherMsg(msg)
									}
								}
							} else {
								this.showPraiseEnhanced(msg)
							}
						}

						this.refreshLock()
						if (this.classInfo.status === 2) {
							this.isClassEnded = true
							this.stopPoll()
						}
					}
				} catch (e) {
					console.error('initUser error', e)
				} finally {
					if (!this.isClassEnded) {
						this.pollTimer = setTimeout(() => {
							this.pollTimer = null;
							this.initUser()
						}, 5000)
					}
					this.noLogin()
				}
			},
			async loadMyStatus() {
				if (this.isClassEnded) return
				try {
					const res = await this.API.get(this.API.school.getMyStatus, {
						courseClassId: this.courseClassId,
						studentId: this.studentId
					})
					if (res.data.code === 200) {
						this.studentStatus = res.data.data
					}
				} catch (e) {} finally {
					this.refreshLock()
					if (!this.isClassEnded) {
						this.myStatusTimer = setTimeout(() => {
							this.myStatusTimer = null;
							this.loadMyStatus()
						}, 5000)
					}
				}
			},
			refreshLock() {
				const global = this.classInfo.controlStudentPage === 1
				const self = this.studentStatus.controlStatus === 1
				if(global){
					this.isFirst=false
				}
				this.isLocked = global || self
				
			},
			async loadNewChat() {
				if (this.isClassEnded) return
				try {
					const res = await this.API.get(this.API.student.pollTeacherMsg, {
						schoolId: this.schoolId,
						courseClassId: this.courseClassId,
						studentId: this.studentId
					})
					const msg = res.data.data
					if (msg) {
						if (msg.type === 'countdown' || msg.noticeText) {
							this.showCountdownNotification(msg)
						} else if (msg.type == 'text') {
							const content = msg.content || ''
							console.log('content',msg)
							if (this.customPageId == 1) {
								if (this.$refs.studentInde) {
									this.$refs.studentInde.forChat(msg)
								}
							} else {
								if (this.$refs.chatPanel) {
									this.$refs.chatPanel.receiveTeacherMsg(msg)
								}
							}
						} else {
							this.showPraiseEnhanced(msg)
						}
					}
				} catch (e) {} finally {
					if (!this.isClassEnded) {
						this.chatPollTimer = setTimeout(() => {
							this.chatPollTimer = null
							this.loadNewChat()
						}, 2000)
					}
				}
			},
			showCountdownNotification(msg) {
				const noticeText = msg.noticeText
				if (!noticeText) return
				let time = Number(noticeText)
				if (isNaN(time)) return
				if (time === 0) {
					this.showAlarmAnimation = true
					setTimeout(() => {
						this.closeAlarmAnimation()
					}, 3000)
				} else {
					let text = ''
					if (time < 60) {
						text = `⏰ 距离活动结束还剩${time}秒`
					} else {
						let minute = Math.floor(time / 60);
						let second = time % 60;
						text = `⏰ 距离活动结束还剩${minute}分${second}秒`
					}
					this.showMarquee = true
					this.marqueeText = text
					setTimeout(() => {
						this.showMarquee = false
					}, 5000)
				}
			},
			showPraiseEnhanced(praiseData) {
				this.triggerPraiseAnimation(praiseData)
			},
			triggerPraiseAnimation(praiseData) {
				this.praiseCache.lastPraiseTime = Date.now()
				this.currentPraise = {
					type: praiseData.praiseType,
					teacherName: praiseData.teacherName || this.classInfo.teacherName,
					praiseId: praiseData.praiseId || praiseData.id
				}
				this.showPraiseAnimation = true
				this.praiseCache.isAnimating = true
				setTimeout(() => {
					this.closePraiseAnimation()
				}, 2000)
			},
			async enterClass() {
				try {
					await this.API.post(this.API.school.postStudentEnter, {
						schoolId: this.schoolId,
						courseClassId: this.courseClassId,
						studentId: this.studentId,
						studentName: this.studentName
					})
				} catch (e) {}
			},
			exitClass() {
				this.loginOpen('退出课堂中...')
				
				this.API.post(this.API.school.postStudentLeave, {
					schoolId: this.schoolId,
					courseClassId: this.courseClassId,
					studentId: this.studentId
				}).finally(() => {
					this.noLogin()
					this.stopShare()
					this.stopPoll()
					this.stopChatPoll()
					this.stopAllPoll();
					this.$router.push('/student/home')
				})
			},
			getPraiseIcon(t) {
				return {
					flower: '🌸',
					thumb: '👍',
					star: '⭐',
					fist: '💪'
				} [t] || '🌟'
			},
			getPraiseLabel(t) {
				return {
					flower: '送你一朵鲜花！',
					thumb: '为你点赞！',
					star: '星星奖励！',
					fist: '加油！'
				} [t] || '表扬！'
			},
			closePraiseAnimation() {
				this.showPraiseAnimation = false
				this.praiseCache.isAnimating = false
			},
			startClassPoll() {
				this.initUser()
			},
			startChatPoll() {
				this.loadNewChat()
			},
			startMyStatusPoll() {
				this.loadMyStatus()
			},
			stopPoll() {
				clearTimeout(this.pollTimer);
				this.pollTimer = null
			},
			stopChatPoll() {
				clearTimeout(this.chatPollTimer);
				this.chatPollTimer = null
			},
			stopMyStatusTimer() {
				clearTimeout(this.myStatusTimer);
				this.myStatusTimer = null
			},
			startAlarmPoll() {
				this.loadAlarmBroadcast()
				this.alarmPollTimer = setInterval(() => {
					this.loadAlarmBroadcast()
				}, 2000)
				this.alarmCache.cacheCleanupTimer = setInterval(() => {
					this.alarmCache.processedIds = []
				}, 30000)
			},
			stopAlarmPoll() {
				if (this.alarmPollTimer) {
					clearInterval(this.alarmPollTimer)
					this.alarmPollTimer = null
				}
			},
			async loadAlarmBroadcast() {
				if (this.isClassEnded) return
				try {
					const res = await this.API.get('/school/broadcast/getCurrent', {
						courseClassId: this.courseClassId
					})
					if (res.data.code === 200 && res.data.data) {
						const broadcast = res.data.data
						if (this.alarmCache.processedIds.includes(broadcast.broadcastId)) {
							return
						}
						const now = Date.now()
						const endTime = new Date(broadcast.endTime).getTime()
						if (now >= endTime) {
							this.handleAlarmBroadcast(broadcast)
						} else {
							const remainingTime = Math.ceil((endTime - now) / 1000)
							this.updateAlarmCountdown(broadcast, remainingTime)
						}
					}
				} catch (err) {
					console.error('加载闹钟广播失败:', err)
				}
			},
			handleAlarmBroadcast(broadcast) {
				if (this.alarmCache.processedIds.includes(broadcast.broadcastId)) {
					return
				}
				this.alarmCache.processedIds.push(broadcast.broadcastId)
				if (this.alarmCache.lastAlarmTime && Date.now() - this.alarmCache.lastAlarmTime < 3000) {
					return
				}
				this.alarmCache.lastAlarmTime = Date.now()
				this.currentAlarm = {
					broadcastId: broadcast.broadcastId,
					broadcastName: broadcast.broadcastName || '时间到',
					duration: broadcast.duration || 0,
					remainingTime: 0
				}
				this.showAlarmEnhanced(broadcast)
			},
			updateAlarmCountdown(broadcast, remainingTime) {
				if (this.showAlarmAnimation && this.currentAlarm.broadcastId === broadcast.broadcastId) {
					this.currentAlarm.remainingTime = remainingTime
					return
				}
				if (this.showAlarmAnimation) {
					return
				}
				this.currentAlarm = {
					broadcastId: broadcast.broadcastId,
					broadcastName: broadcast.broadcastName || '时间到',
					duration: broadcast.duration || 0,
					remainingTime: remainingTime
				}
				this.showAlarmAnimation = true
				this.alarmCache.isAnimating = true
				setTimeout(() => {
					this.closeAlarmAnimation()
				}, 5000)
			},
			showAlarmEnhanced(broadcast) {
				if (this.praiseCache.isAnimating) {
					this.alarmCache.alarmDebounceTimer = setTimeout(() => {
						this.showAlarmEnhanced(broadcast)
					}, 500)
					return
				}
				if (this.showAlarmAnimation) {
					this.playAlarmSound()
					return
				}
				this.triggerAlarmAnimation(broadcast)
			},
			triggerAlarmAnimation(broadcast) {
				this.alarmCache.lastAlarmTime = Date.now()
				this.alarmCache.isAnimating = true
				this.playAlarmSound()
				this.showAlarmAnimation = true
				setTimeout(() => {
					this.closeAlarmAnimation()
				}, 5000)
			},
			closeAlarmAnimation() {
				this.showAlarmAnimation = false
				this.alarmCache.isAnimating = false
				this.currentAlarm = {
					broadcastId: null,
					broadcastName: '时间到',
					duration: 0,
					remainingTime: 0
				}
			},
			playAlarmSound() {
				try {
					const audioContext = new(window.AudioContext || window.webkitAudioContext)()
					const oscillator = audioContext.createOscillator()
					const gainNode = audioContext.createGain()
					oscillator.connect(gainNode)
					gainNode.connect(audioContext.destination)
					oscillator.frequency.value = 880
					oscillator.type = 'sine'
					gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
					let playCount = 0
					const playAlarm = () => {
						if (playCount < 3) {
							oscillator.start()
							setTimeout(() => {
								oscillator.stop()
								playCount++
								if (playCount < 3) {
									setTimeout(playAlarm, 500)
								}
							}, 300)
						}
					}
					playAlarm()
				} catch (err) {
					console.error('播放闹钟音效失败:', err)
				}
			},
			checkIsMobile() {
				this.isMobile = window.innerWidth < 768
				window.addEventListener('resize', () => {
					this.isMobile = window.innerWidth < 768
				})
			},
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					background: 'rgba(0,0,0,0.7)'
				})
			},
			noLogin() {
				if (this.login) {
					this.login.close()
				}
			},
		}
	};
</script>

<style scoped>
	.countdown-notification {
		position: fixed;
		top: 80px;
		left: 50%;
		transform: translateX(-50%);
		background: #ffffff;
		padding: 16px 24px;
		border-radius: 12px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
		display: flex;
		align-items: center;
		gap: 12px;
		z-index: 10000;
		animation: countdown-slide-in 0.3s ease;
	}

	.countdown-icon {
		font-size: 28px;
	}

	.countdown-text {
		font-size: 16px;
		font-weight: 500;
		color: #333;
	}

	@keyframes countdown-slide-in {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(-20px);
		}

		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
	}

	.countdown-notification.fade-out {
		animation: countdown-slide-out 0.5s ease forwards;
	}

	@keyframes countdown-slide-out {
		from {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}

		to {
			opacity: 0;
			transform: translateX(-50%) translateY(-20px);
		}
	}

	.class-page {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		background: linear-gradient(135deg, #e0f7fa 0%, #fff8e1 50%, #fce4ec 100%);
		overflow: hidden;
		box-sizing: border-box;
	}

	.top-bar {
		flex-shrink: 0;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
		color: #fff;
		padding: 12px 20px;
		min-height: 50px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
	}

	.top-bar h2 {
		margin: 0;
		font-size: 20px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.exit-btn {
		flex-shrink: 0;
		background: #ff6b6b;
		color: #fff;
		border: none;
		padding: 8px 16px;
		border-radius: 30px;
		font-size: 14px;
		white-space: nowrap;
	}

	.toggle-left-btn {
		position: fixed;
		top: 60px;
		left: 10px;
		z-index: 99;
		background: #667eea;
		color: #fff;
		border: none;
		padding: 8px 14px;
		border-radius: 30px;
		font-size: 14px;
		flex-shrink: 0;
	}

	.layout-container {
		flex: 1;
		width: 100%;
		display: flex;
		gap: 10px;
		padding: 8px;
		overflow: hidden;
		position: relative;
		box-sizing: border-box;
	}

	.lock-mask,
	.end-mask {
		position: fixed;
		left: 0;
		top: 0;
		width: 100vw;
		height: 100vh;
		display: grid;
		place-items: center;
		color: #fff;
		font-size: 20px;
		z-index: 999;
		box-sizing: border-box;
	}

	.lock-mask {
		background: rgba(255, 107, 107, 0.9);
	}

	.end-mask {
		background: rgba(102, 126, 234, 0.9);
	}

	.praise-animation-container {
		position: fixed;
		left: 0;
		top: 0;
		width: 100vw;
		height: 100vh;
		z-index: 9999;
		background: rgba(0, 0, 0, 0.3);
		display: flex;
		align-items: center;
		justify-content: center;
		backdrop-filter: blur(5px);
	}

	.praise-content {
		text-align: center;
		position: relative;
		z-index: 10000;
		background: #ffffff;
		padding: 40px 60px;
		border-radius: 16px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
		max-width: 80vw;
		min-width: 280px;
	}

	.praise-icon {
		font-size: 60px;
		margin-bottom: 16px;
	}

	.praise-text {
		font-size: 20px;
		font-weight: 600;
		color: #333;
		margin-bottom: 8px;
	}

	.praise-subtext {
		font-size: 14px;
		color: #666;
	}

	@media (max-height: 500px) and (orientation: landscape) {
		.top-bar {
			padding: 8px 16px !important;
			min-height: 44px !important;
		}

		.top-bar h2 {
			font-size: 16px !important;
		}

		.exit-btn {
			padding: 6px 12px !important;
			font-size: 13px !important;
		}

		.toggle-left-btn {
			top: 50px !important;
			padding: 6px 12px !important;
			font-size: 13px !important;
		}

		.layout-container {
			padding: 5px !important;
			gap: 8px !important;
		}
	}

	.alarm-animation-container {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
		cursor: pointer;
		backdrop-filter: blur(5px);
	}

	.alarm-content {
		text-align: center;
		background: #ffffff;
		padding: 40px 60px;
		border-radius: 20px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
	}

	.alarm-icon-container {
		position: relative;
		width: 100px;
		height: 100px;
		margin: 0 auto 20px;
	}

	.alarm-icon {
		font-size: 80px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.alarm-ring {
		display: none;
	}

	.alarm-title {
		font-size: 28px;
		font-weight: bold;
		color: #333;
		margin-bottom: 12px;
	}

	.alarm-subtitle {
		font-size: 20px;
		color: #666;
		margin-bottom: 16px;
	}

	.alarm-timer {
		font-size: 36px;
		font-weight: bold;
		color: #666;
		margin-bottom: 16px;
	}

	.alarm-hint {
		font-size: 14px;
		color: #999;
		margin-top: 20px;
	}

	.marquee-notice {
		position: fixed;
		top: 50px;
		left: 0;
		width: 100vw;
		height: 36px;
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
		line-height: 36px;
		overflow: hidden;
		z-index: 99999;
		white-space: nowrap;
		box-sizing: border-box;
		padding: 0 10px;
	}

	.marquee-content {
		display: inline-block;
		animation: marquee-scroll linear infinite;
		padding-left: 100%;
		font-size: 14px;
		letter-spacing: 1px;
	}

	@keyframes marquee-scroll {
		0% {
			transform: translateX(0);
		}

		100% {
			transform: translateX(-100%);
		}
	}
</style>